export default __webpack_public_path__ + "static/Plots0045-0450e3d7c4e8332d282ec33e7c71b522.jpg";